import type { DocumentDTO } from 'src/types/llm';

const HIDDEN_META_KEYS = [
	'fundstelle',
	'xml_hash',
	'pdf_hash',
	'id',
	'url',
	'pdf_url',
	'xml_url',
	'external_id',
	'herausgeber',
	'vorgangsbezug',
	'vorgangsbezug_anzahl',
	'abstract',
	'deskriptor',
	'beratungsstand',
	'drucksachetyp',
	'vorgang_id',
	'typ',
	'vorgangstyp'
];

export function stripMeta<T extends { meta?: Record<string, unknown> }>(obj: T): T {
	if (!obj.meta) {
		return obj;
	}
	const meta = Object.fromEntries(
		Object.entries(obj.meta).filter(([key]) => !HIDDEN_META_KEYS.includes(key))
	);
	return { ...obj, meta };
}

export function stripHiddenMeta(doc: DocumentDTO): DocumentDTO {
	const stripped = stripMeta(doc);
	if (!stripped.resource) {
		return stripped;
	}
	return { ...stripped, resource: stripMeta(stripped.resource) };
}
